module.exports = new __parcel__URL__("meeting-notes.7a25198d.png").toString();